<template>
  <AuthLayout
    :title="$t('auth.forgot.title')"
    :subtitle="sent ? '' : $t('auth.forgot.subtitle')"
  >
    <!--
      Always the same confirmation, whether or not the address has an account.
      Saying "no such user" would let anyone test which emails are registered
      here, and the API deliberately answers the same way.
    -->
    <div v-if="sent" role="status" class="flex flex-col gap-4">
      <p class="text-muted leading-relaxed">
        {{ $t("auth.forgot.sentBody", { email: submittedEmail }) }}
      </p>
      <p class="text-subtle text-sm leading-relaxed">
        {{ $t("auth.forgot.sentHint") }}
      </p>
      <button
        type="button"
        class="self-start text-highlight text-sm hover:underline"
        @click="reset"
      >
        {{ $t("auth.forgot.tryAnother") }}
      </button>
    </div>

    <form v-else class="flex flex-col gap-5" @submit.prevent="submit">
      <HoneypotField ref="honeypot" />
      <InputField
        v-model="email"
        :label="$t('account.email')"
        type="email"
        name="email"
        inputmode="email"
        autocomplete="email"
        required
        :placeholder="$t('auth.forgot.placeholder')"
      />

      <Button class="mt-2 w-full text-lg" :loading="loading">
        {{ $t("auth.forgot.submit") }}
      </Button>
      <ErrorLabel :error="errorMessage" />
    </form>
  </AuthLayout>
</template>

<script>
import AuthLayout from "@/components/auth/AuthLayout.vue";
import Button from "@/components/common/Button.vue";
import ErrorLabel from "@/components/common/ErrorLabel.vue";
import HoneypotField from "@/components/common/HoneypotField.vue";

export default {
  name: "ForgotPassword",
  components: { AuthLayout, Button, ErrorLabel, HoneypotField },

  data() {
    return {
      email: "",
      submittedEmail: "",
      loading: false,
      sent: false,
      errorMessage: "",
    };
  },

  mounted() {
    // Carry over whatever they had typed on the login form.
    this.email = this.$route.query.email ?? "";
  },

  methods: {
    submit() {
      if (this.loading) return;

      this.loading = true;
      this.errorMessage = "";
      const email = this.email.trim();

      this.$store
        .dispatch("sendPasswordResetMail", {
          email,
          ...this.$refs.honeypot.payload(),
        })
        .then(() => {
          this.submittedEmail = email;
          this.sent = true;
        })
        .catch(() => {
          // Only a transport failure can land here; the API returns 200 even
          // for unknown addresses.
          this.errorMessage = this.$t("auth.forgot.error").toString();
        })
        .finally(() => (this.loading = false));
    },

    reset() {
      this.sent = false;
      this.errorMessage = "";
    },
  },
};
</script>
